import { adminInstance } from "@/api/instance";

export default async function (userId, data) {
  return adminInstance.post(`/user/${userId}`, data);
}
